let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1R7i6")).then(() => parcelRequire('ci4jd'));